import { eApplicationActions } from './eApplicationActions';

export interface IDeleteOrderLinkRequest {
  type: eApplicationActions.DeleteOrderLinkRequest;
}

export const createDeleteOrderLinkRequestAction = (): IDeleteOrderLinkRequest => ({
  type: eApplicationActions.DeleteOrderLinkRequest,
});
